import { displayErrorNotification } from 'utils/displayNudosStandardNotifications';
import { IOrderCardUserData } from './OrderSummaryCard';

export const formatUserData = (user: IOrderCardUserData) => {
  try {
    return {
      email: user?.email,
      fullName: user?.firstName && user?.lastName ? `${user.firstName} ${user.lastName}` : '',
      phone: user?.phoneCode && user?.phone ? `+${user.phoneCode} ${user.phone}` : ''
    };
  } catch (error) {
    displayErrorNotification();
  }
};
